import { useQuery,useMutation,useQueryClient } from "@tanstack/react-query"
import { SHIPPING_RULES, USER_ORDERS,ORDER_INVOICE_KEY } from "../constants/query.constants"
import { addUserOrder,cancelUserOrder,getShippingRules,getUserOrders,getOrderInvoice } from "../repositories/orders/orderRepository"
import toast from "react-hot-toast";

export const useGetOrdersQuery = () => {
  return useQuery({
    queryKey: [USER_ORDERS],
    queryFn: getUserOrders,
    staleTime: 0,       
    cacheTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    retry: 2,
  });
};

export const useGetOrderInvoiceQuery  = (invoiceNumber) => {
  return useQuery({
    queryKey: [ORDER_INVOICE_KEY,invoiceNumber],
    queryFn: ()=>getOrderInvoice(invoiceNumber),
    enabled: !!invoiceNumber,
  });
};

export const useAddOrderMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: addUserOrder,
    onSuccess: () => {
      queryClient.invalidateQueries([USER_ORDERS]);
    },
  });
};


export const useCancelOrderMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: cancelUserOrder,

    onSuccess: (res) => {
      toast.success(res?.message || "Order cancelled successfully");
      queryClient.invalidateQueries({ queryKey: [USER_ORDERS] });
    },

    onError: (err) => {
      const msg =
        err?.response?.data?.message || "Failed to cancel order. Try again!";
      toast.error(msg);
    },
  });
};



export const useShippingRulesQuery = () => {
  return useQuery({
    queryKey: [SHIPPING_RULES],
    queryFn: getShippingRules,
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
    retry: 1,
  });
};